
/**
 * Utilities for generating CSV content from different data types
 */

// Helper to escape cells with commas
export const escapeCSVCell = (cell: any): string => {
  const cellValue = cell?.toString() || '';
  if (cellValue.includes(',')) {
    return `"${cellValue}"`;
  }
  return cellValue;
};

// Helper to create CSV rows
export const createCSVRow = (values: any[]): string => {
  const escapedValues = values.map(cell => escapeCSVCell(cell));
  return escapedValues.join(',') + '\n';
};

// Generate CSV headers
export const generateCSVHeaders = (headers: string[]): string => {
  return createCSVRow(headers);
};
